import { useQuery } from "@tanstack/react-query";
import { privateAxios } from "../axiosInstances";
import { creditNotesQueryKeys } from "../query-keys/credit-note.query-keys";
import {
  AcExpoCreditNoteItemsResponse,
  CreditNoteFilters,
  CreditNoteForList,
  Paginated,
  PaginatedResponse,
  QueryArgs,
  Sortable,
} from "@ac-expo/api-types";

const getCreditNotes = async (
  filters?: Sortable<Paginated<CreditNoteFilters>>
) => {
  const { data } = await privateAxios.get<PaginatedResponse<CreditNoteForList>>(
    "/credit-notes",
    { params: filters }
  );

  return data;
};

export const useGetCreditNotesQuery = (
  filters?: Sortable<Paginated<CreditNoteFilters>>,
  options?: QueryArgs<PaginatedResponse<CreditNoteForList>>
) => {
  return useQuery({
    queryKey: creditNotesQueryKeys.lists(filters),
    queryFn: () => getCreditNotes(filters),
    ...options,
  });
};

const getAcExpoCreditNoteItems = async (orderId: string) => {
  const { data } = await privateAxios.get<AcExpoCreditNoteItemsResponse>(
    `/credit-notes/ac-expo/orders/${orderId}/items`
  );
  return data;
};

export const useGetAcExpoCreditNoteItemsQuery = (
  orderId?: string,
  options?: QueryArgs<AcExpoCreditNoteItemsResponse>
) => {
  return useQuery({
    queryKey: creditNotesQueryKeys.acExpo.orderItems(orderId),
    queryFn: () => getAcExpoCreditNoteItems(orderId as string),
    enabled: !!orderId,
    ...options,
  });
};
